"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = require("./Input.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Input = function Input(_ref) {
  var id = _ref.id,
      label = _ref.label,
      disabled = _ref.disabled,
      _onChange = _ref.onChange,
      _onClick = _ref.onClick,
      helper = _ref.helper,
      error = _ref.error,
      props = _objectWithoutProperties(_ref, ["id", "label", "disabled", "onChange", "onClick", "helper", "error"]);

  var hasError = !!error;
  var inputProps = {
    id: id,
    disabled: disabled,
    onChange: function onChange(e) {
      if (!disabled) {
        _onChange(e);
      }
    },
    onClick: function onClick(e) {
      if (!disabled) {
        _onClick(e);
      }
    }
  };
  return _react["default"].createElement(_Input.StyleBase, null, !!label && _react["default"].createElement(_Input.LabelStyle, {
    htmlFor: id
  }, label), !!helper && _react["default"].createElement(_Input.HelperText, null, helper), _react["default"].createElement(_Input.InputStyle, _extends({
    hasError: hasError
  }, inputProps, props)), hasError && _react["default"].createElement(_Input.ErrorText, null, error));
};

Input.propTypes = {
  id: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  helper: _propTypes["default"].string,
  error: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onClick: _propTypes["default"].func
};
Input.defaultProps = {
  disabled: false,
  type: 'text',
  onChange: function onChange() {},
  onClick: function onClick() {}
};
var _default = Input;
exports["default"] = _default;